export default {
  appUrl: process.env.REACT_APP_URL,
  appEnv: process.env.REACT_APP_ENV,
  auth0: {
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
  },
  mulesoft: {
    apiUrl: process.env.REACT_APP_MULESOFT_API_URL,
    envIndicator: process.env.REACT_APP_MULESOFT_ENV_INDICATOR,
  },
  oneIncPrefix: process.env.REACT_APP_ONEINC_PREFIX,
  oneIncWebhook: process.env.REACT_APP_ONEINC_WEBHOOK,
  mockPolicies: process.env.REACT_APP_MOCK_POLICIES,
  datadog: {
    env: process.env.REACT_APP_DD_ENV,
    id: process.env.REACT_APP_DD_ID,
    site: process.env.REACT_APP_DD_SITE,
    secret: process.env.REACT_APP_DD_TOKEN,
  },
  banner: {
    display: process.env.REACT_APP_BANNER_DISPLAY,
    msg: process.env.REACT_APP_BANNER_MSG,
  },
  mfaBanner: {
    display: process.env.REACT_APP_MFA_BANNER_DISPLAY,
  },
  briteVerify: {
    apiKey: process.env.REACT_APP_BRITEVERIFY_API_KEY,
    bypass: process.env.REACT_APP_BRITEVERIFY_BYPASS === 'true',
  },
  maintenancePage: process.env.REACT_APP_MAINTENANCE_PAGE,
  fnol: process.env.REACT_APP_FNOL,
  mockData: process.env.REACT_APP_MOCKDATA,
  healthCheck: process.env.REACT_APP_HEALTH_CHECK,
  disableEndorsement: process.env.REACT_APP_DISABLE_ENDORSEMENTS,
  disableIPXEndorsement: process.env.REACT_APP_DISABLE_IPX_ENDORSEMENTS,
  disableFusionEndorsement: process.env.REACT_APP_DISABLE_FUSION_ENDORSEMENTS,
  dp3Enabled: process.env.REACT_APP_DP3_ENABLED === 'true',
};
